import React, { useState } from 'react';
import { Users, PenSquare, Save, X } from 'lucide-react';
import { actualizarMatricula } from '../../services/matriculaService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DesarrolloMotrizLenguaje = ({ matricula }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    gateo: matricula.desarrolloMotriz?.gateo === 'true',
    edad_inicio_gateo: matricula.desarrolloMotriz?.edad_inicio_gateo || '',
    edad_inicio_caminar: matricula.desarrolloMotriz?.edad_inicio_caminar || '',
    tipo_lactancia: matricula.desarrolloMotriz?.tipo_lactancia || '',
    edad_fin_lactancia: matricula.desarrolloMotriz?.edad_fin_lactancia || '',
    mano_dominante: matricula.desarrolloMotriz?.mano_dominante || '',
    control_esfinteres_diurno: matricula.desarrolloMotriz?.control_esfinteres_diurno === 'true',
    control_esfinteres_nocturno: matricula.desarrolloMotriz?.control_esfinteres_nocturno === 'true',
    edad_control_esfinteres: matricula.desarrolloMotriz?.edad_control_esfinteres || '',
    detalles_esfinteres: matricula.desarrolloMotriz?.detalles_esfinteres || '',
    idioma_casa: matricula.desarrolloMotriz?.idioma_casa || '',
    edad_balbuceo: matricula.desarrolloMotriz?.edad_balbuceo || '',
    edad_palabras_sueltas: matricula.desarrolloMotriz?.edad_palabras_sueltas || '',
    edad_hablar: matricula.desarrolloMotriz?.edad_hablar || '',
    terapia_lenguaje: matricula.desarrolloMotriz?.terapia_lenguaje === 'true',
    terapia_lenguaje_detalle: matricula.desarrolloMotriz?.terapia_lenguaje_detalle || '',
    duracion_terapia_lenguaje: matricula.desarrolloMotriz?.duracion_terapia_lenguaje || '',
    companero_sueno: matricula.desarrolloMotriz?.companero_sueno || '',
    edad_inicio_dormir_solo: matricula.desarrolloMotriz?.edad_inicio_dormir_solo || '',
    dificultades_sueno: matricula.desarrolloMotriz?.dificultades_sueno || ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setErrors(prev => ({
      ...prev,
      [name]: ''
    }));
  };

  const toggleCheckboxField = (fieldName) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: !prev[fieldName]
    }));
  };

  const handleNumberInputChange = (e) => {
    const { name, value } = e.target;
    if (value === '' || (/^\d+$/.test(value) && parseInt(value) >= 0)) {
      handleInputChange({
        target: {
          name,
          value: value === '' ? '' : parseInt(value)
        }
      });
    }
  };

  const handleSubmit = async () => {
    try {
      await actualizarMatricula(matricula.nino.id_child, {
        desarrolloMotriz: formData
      });
      setIsEditing(false);
      matricula.desarrolloMotriz = formData;
      toast.success('Desarrollo motriz y lenguaje actualizado exitosamente', {
        position: 'top-right',
        autoClose: 3000,
        style: { marginTop: '10px' }
      });
    } catch (error) {
      console.error('Error al actualizar:', error);
      toast.error('Error al actualizar los datos: ' + error.message, {
        position: 'top-right',
        autoClose: 3000,
        style: { marginTop: '10px' }
      });
    }
  };

  const inputStyle = "w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500";

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 relative">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900 flex items-center">
          <Users className="mr-2 text-indigo-500" size={20} />
          Desarrollo Motriz y Lenguaje
        </h3>
        {!isEditing ? (
          <PenSquare 
            className="text-indigo-500 cursor-pointer hover:text-indigo-600" 
            size={20} 
            onClick={() => setIsEditing(true)}
          />
        ) : (
          <div className="flex gap-2">
            <Save 
              className="text-green-500 cursor-pointer hover:text-green-600" 
              size={20} 
              onClick={handleSubmit}
            />
            <X 
              className="text-red-500 cursor-pointer hover:text-red-600" 
              size={20} 
              onClick={() => setIsEditing(false)}
            />
          </div>
        )}
      </div>

      <div className="space-y-4">
        {Object.entries({
          '¿El niño gateó?': isEditing ? (
            <div>
              <div className="flex items-center space-x-4 mb-2">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    checked={formData.gateo}
                    onChange={() => toggleCheckboxField('gateo')}
                    className="form-radio text-indigo-600"
                  /> <span className="ml-2 text-sm">Sí</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    checked={!formData.gateo}
                    onChange={() => toggleCheckboxField('gateo')}
                    className="form-radio text-indigo-600"
                  /> <span className="ml-2 text-sm">No</span>
                </label>
              </div>
              {formData.gateo && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Edad de inicio del gateo
                  </label>
                  <input
                    type="number"
                    name="edad_inicio_gateo"
                    value={formData.edad_inicio_gateo}
                    onChange={handleNumberInputChange}
                    placeholder="Ingrese la edad en meses cuando empezó a gatear"
                    className={inputStyle}
                    min="0"
                  />
                </div>
              )}
            </div>
          ) : formData.gateo ? `Sí, a los ${formData.edad_inicio_gateo} meses` : 'No',

          'Edad de inicio de caminata': isEditing ? (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                ¿A qué edad comenzó a caminar?
              </label>
              <input
                type="number"
                name="edad_inicio_caminar"
                value={formData.edad_inicio_caminar}
                onChange={handleNumberInputChange}
                placeholder="Ingrese la edad en meses cuando empezó a caminar"
                className={inputStyle}
                min="0"
              />
            </div>
          ) : `${formData.edad_inicio_caminar} meses`,

          'Información sobre lactancia': isEditing ? (
            <div className="space-y-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Tipo de lactancia
                </label>
                <select
                  name="tipo_lactancia"
                  value={formData.tipo_lactancia}
                  onChange={handleInputChange}
                  className={inputStyle}
                >
                  <option value="">Seleccione el tipo de lactancia</option>
                  <option value="Materna">Materna</option>
                  <option value="Artificial">Artificial</option>
                  <option value="Mixta">Mixta</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Edad de finalización de lactancia
                </label>
                <input
                  type="number"
                  name="edad_fin_lactancia"
                  value={formData.edad_fin_lactancia}
                  onChange={handleNumberInputChange}
                  placeholder="¿A qué edad dejó la lactancia? (en meses)"
                  className={inputStyle}
                  min="0"
                />
              </div>
            </div>
          ) : `${formData.tipo_lactancia} hasta los ${formData.edad_fin_lactancia} meses`,

          'Mano dominante': isEditing ? (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                ¿Qué mano usa predominantemente?
              </label>
              <select
                name="mano_dominante"
                value={formData.mano_dominante}
                onChange={handleInputChange}
                className={inputStyle}
              >
                <option value="">Seleccione la mano dominante</option>
                <option value="Izquierda">Izquierda</option>
                <option value="Derecha">Derecha</option>
                <option value="Ambas">Ambas</option>
              </select>
            </div>
          ) : formData.mano_dominante,

          'Control de esfínteres': isEditing ? (
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Control diurno
                </label>
                <div className="flex items-center space-x-4">
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      checked={formData.control_esfinteres_diurno}
                      onChange={() => toggleCheckboxField('control_esfinteres_diurno')}
                      className="form-radio text-indigo-600"
                    /> <span className="ml-2 text-sm">Sí</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      checked={!formData.control_esfinteres_diurno}
                      onChange={() => toggleCheckboxField('control_esfinteres_diurno')}
                      className="form-radio text-indigo-600"
                    /> <span className="ml-2 text-sm">No</span>
                  </label>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Control nocturno
                </label>
                <div className="flex items-center space-x-4">
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      checked={formData.control_esfinteres_nocturno}
                      onChange={() => toggleCheckboxField('control_esfinteres_nocturno')}
                      className="form-radio text-indigo-600"
                    /> <span className="ml-2 text-sm">Sí</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      checked={!formData.control_esfinteres_nocturno}
                      onChange={() => toggleCheckboxField('control_esfinteres_nocturno')}
                      className="form-radio text-indigo-600"
                    /> <span className="ml-2 text-sm">No</span>
                  </label>
                </div>
              </div>

              {formData.control_esfinteres_diurno && formData.control_esfinteres_nocturno && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Edad de control de esfínteres
                  </label>
                  <input
                    type="number"
                    name="edad_control_esfinteres"
                    value={formData.edad_control_esfinteres}
                    onChange={handleNumberInputChange}
                    placeholder="¿A qué edad logró el control? (en meses)"
                    className={inputStyle}
                    min="0"
                  />
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Observaciones adicionales
                </label>
                <textarea
                  name="detalles_esfinteres"
                  value={formData.detalles_esfinteres}
                  onChange={handleInputChange}
                  placeholder="Ingrese cualquier detalle relevante sobre el control de esfínteres"
                  className={inputStyle}
                  rows="2"
                />
              </div>
            </div>
          ) : `Diurno: ${formData.control_esfinteres_diurno ? 'Sí' : 'No'}, Nocturno: ${formData.control_esfinteres_nocturno ? 'Sí' : 'No'}, ${formData.control_esfinteres_diurno && formData.control_esfinteres_nocturno ? `Edad: ${formData.edad_control_esfinteres || 'No especificada'} meses` : ''}`,

          'Idioma principal en casa': isEditing ? (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                ¿Qué idioma(s) se habla(n) en casa?
              </label>
              <input
                name="idioma_casa"
                value={formData.idioma_casa}
                onChange={handleInputChange}
                className={inputStyle}
                placeholder="Especifique el/los idioma(s) que se hablan en casa"
              />
            </div>
          ) : formData.idioma_casa,

          'Desarrollo del lenguaje': isEditing ? (
            <div className="space-y-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Edad de balbuceo
                </label>
                <input
                  type="number"
                  name="edad_balbuceo"
                  value={formData.edad_balbuceo}
                  onChange={handleNumberInputChange}
                  placeholder="¿A qué edad comenzó a balbucear? (en meses)"
                  className={inputStyle}
                  min="0"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Edad de primeras palabras
                </label>
                <input
                  type="number"
                  name="edad_palabras_sueltas"
                  value={formData.edad_palabras_sueltas}
                  onChange={handleNumberInputChange}
                  placeholder="¿A qué edad dijo sus primeras palabras? (en meses)"
                  className={inputStyle}
                  min="0"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Edad de habla fluida
                </label>
                <input
                  type="number"
                  name="edad_hablar"
                  value={formData.edad_hablar}
                  onChange={handleNumberInputChange}
                  placeholder="¿A qué edad comenzó a hablar fluidamente? (en meses)"
                  className={inputStyle}
                  min="0"
                />
              </div>
            </div>
          ) : `Balbuceo: ${formData.edad_balbuceo} meses, Palabras sueltas: ${formData.edad_palabras_sueltas} meses, Hablar: ${formData.edad_hablar} meses`,

          'Terapia de lenguaje': isEditing ? (
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                ¿Ha recibido terapia de lenguaje?
              </label>
              <div className="flex items-center space-x-4 mb-2">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    checked={formData.terapia_lenguaje}
                    onChange={() => toggleCheckboxField('terapia_lenguaje')}
                    className="form-radio text-indigo-600"
                  /> <span className="ml-2 text-sm">Sí</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    checked={!formData.terapia_lenguaje}
                    onChange={() => toggleCheckboxField('terapia_lenguaje')}
                    className="form-radio text-indigo-600"
                  /> <span className="ml-2 text-sm">No</span>
                </label>
              </div>
              {formData.terapia_lenguaje && (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Detalles de la terapia
                    </label>
                    <textarea
                      name="terapia_lenguaje_detalle"
                      value={formData.terapia_lenguaje_detalle}
                      onChange={handleInputChange}
                      placeholder="Describa el tipo de terapia y los avances logrados"
                      className={inputStyle}
                      rows="2"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Duración de la terapia
                    </label>
                    <input
                      name="duracion_terapia_lenguaje"
                      value={formData.duracion_terapia_lenguaje}
                      onChange={handleInputChange}
                      placeholder="Especifique el tiempo de duración de la terapia"
                      className={inputStyle}
                    />
                  </div>
                </>
              )}
            </div>
          ) : formData.terapia_lenguaje ? `Sí - ${formData.terapia_lenguaje_detalle} (Duración: ${formData.duracion_terapia_lenguaje || 'No especificada'})` : 'No',

          'Hábitos de sueño': isEditing ? (
            <div className="space-y-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Compañía durante el sueño
                </label>
                <input
                  name="companero_sueno"
                  value={formData.companero_sueno}
                  onChange={handleInputChange}
                  placeholder="¿Con quién duerme habitualmente el niño?"
                  className={inputStyle}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Edad de inicio de sueño independiente
                </label>
                <input
                  type="number"
                  name="edad_inicio_dormir_solo"
                  value={formData.edad_inicio_dormir_solo}
                  onChange={handleNumberInputChange}
                  placeholder="¿A qué edad comenzó a dormir solo? (en meses)"
                  className={inputStyle}
                  min="0"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Dificultades en el sueño
                </label>
                <textarea
                  name="dificultades_sueno"
                  value={formData.dificultades_sueno}
                  onChange={handleInputChange}
                  placeholder="Describa cualquier dificultad relacionada con el sueño"
                  className={inputStyle}
                  rows="2"
                />
              </div>
            </div>
          ) : `Duerme con: ${formData.companero_sueno || 'No especificado'}, Inicio dormir solo: ${formData.edad_inicio_dormir_solo || 'No especificado'} meses, Dificultades: ${formData.dificultades_sueno || 'Ninguna'}`

        }).map(([label, value]) => (
          <div key={label} className="space-y-1">
            <span className="text-sm font-medium text-gray-500">{label}</span>
            <div className="text-gray-900">{value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DesarrolloMotrizLenguaje;
